module.exports = __webpack_public_path__ + "img/packages.424ffb37.jpg";